import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dd6c3dd8"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  type: "checkbox",
  class: "absolute top-6 right-6 md:hidden"
}, null, -1))
const _hoisted_2 = { class: "w-full flex flex-col md:flex-row justify-center md:justify-between" }
const _hoisted_3 = { class: "md:w-1/12" }
const _hoisted_4 = { class: "hidden md:block w-20 pt-1" }
const _hoisted_5 = { class: "mb-4 md:mb-0 md:w-3/4" }
const _hoisted_6 = { class: "text-red-600 text-regular md:text-red-400 font-semibold leading-10" }
const _hoisted_7 = { class: "mb-4 md:mb-0 md:w-1/6" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon-arrow-right text-xs ml-2 mt-1" }, null, -1))
const _hoisted_9 = { key: 0 }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "block w-full bg-gray-200 h-0.5 my-4" }, null, -1))
const _hoisted_11 = { class: "flex flex-row mb-2" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "md:w-1/12" }, null, -1))
const _hoisted_13 = { class: "md:w-1/12 font-bold" }
const _hoisted_14 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_expand_button = _resolveComponent("expand-button")!

  return (_openBlock(), _createElementBlock("div", {
    class: "w-full justify-center bg-white text-light text-black rounded p-4 cursor-pointer text-justify relative mb-2",
    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isExpanded = !_ctx.isExpanded))
  }, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_expand_button, {
            modelValue: _ctx.isExpanded,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isExpanded) = $event)),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isExpanded = !_ctx.isExpanded))
          }, null, 8, ["modelValue"])
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t("bulk_parcels.errors.item.id_label", { id: _ctx.parcel.id })), 1)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("button", {
          class: "error-button py-1.5 px-5 rounded float-right",
          onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.$emit('editParcel', _ctx.parcel.id)), ["stop"]))
        }, [
          _createTextVNode(_toDisplayString(_ctx.$t("bulk_parcels.errors.item.action_button")) + " ", 1),
          _hoisted_8
        ])
      ])
    ]),
    (_ctx.isExpanded)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.$t("bulk_parcels.errors.item.details.description")), 1),
            _createElementVNode("p", {
              class: "md:w-3/4",
              innerHTML: _ctx.prepareErrors(_ctx.parcel.validation_errors)
            }, null, 8, _hoisted_14)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}